import { getEnvVariable } from './getEnvVariable'

const tokenName = (): string => getEnvVariable('REACT_APP_AUTH_TOKEN', 'labs_token')
const getToken = (): string | null => localStorage.getItem(tokenName())
const setToken = (token: string): void => localStorage.setItem(tokenName(), `Bearer ${token}`)
const deleteToken = (): void => localStorage.removeItem(tokenName())

const deleteOrganization = (): void => {
  localStorage.removeItem('userName')
  localStorage.removeItem('organizationName')
  localStorage.removeItem('organizationId')
  localStorage.removeItem('nickname')
}

export default {
  getToken,
  setToken,
  deleteToken,
  deleteOrganization,
}
